import React, { useState } from 'react'
import { theme } from '../styles/theme'
import { Header } from '../components/layout/Header'
import { EnhancedQueryBar } from '../components/query/EnhancedQueryBar'
import { MetricsRow } from '../components/dashboard/MetricsCard'
import { MarketOpportunitiesList } from '../components/dashboard/MarketOpportunitiesCard'
import { WorldMapCard } from '../components/dashboard/WorldMapCard'
import { ActivityFeed } from '../components/dashboard/ActivityFeed'
import { useNavigate } from 'react-router-dom'
import apiClient from '../services/api'

export const EnhancedDashboardPage: React.FC = () => {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)

  const handleQuerySubmit = async (query: string) => {
    setLoading(true)
    try {
      await apiClient.executeQuery(query)
      // Navigate to query page to show results
      navigate('/query', { state: { query } })
    } catch (error) {
      console.error('Query failed:', error)
    } finally {
      setLoading(false)
    }
  }

  const handleCountryClick = (countryCode: string) => {
    navigate(`/markets/${countryCode.toLowerCase()}`)
  }

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: theme.colors.background,
    }}>
      <Header />

      <main style={{
        maxWidth: '1440px',
        margin: '0 auto',
        padding: theme.spacing[10],
      }}>
        {/* AI Query Bar - Central floating card */}
        <div style={{ marginBottom: theme.spacing[10] }}>
          <EnhancedQueryBar onSubmit={handleQuerySubmit} loading={loading} />
        </div>

        {/* Metrics Row - 4 KPI cards */}
        <MetricsRow />

        {/* Main Content - Market Opportunities + World Map */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: '40% 60%',
          gap: theme.spacing[6],
          marginBottom: theme.spacing[8],
        }}>
          <MarketOpportunitiesList />
          <WorldMapCard onCountryClick={handleCountryClick} />
        </div>

        {/* Activity Feed */}
        <ActivityFeed />
      </main>
    </div>
  )
}
